const countriesWithDefiniteArticle = [
  'BS', // the Bahamas
  'KY', // the Cayman Islands
  'CF', // the Central African Republic
  'KM', // the Comoros
  'CZ', // the Czech Republic
  'DO', // the Dominican Republic
  'FK', // the Falkland Islands
  'GM', // the Gambia
  'IM', // the Isle of Man
  'CI', // the Ivory Coast
  'MV', // the Maldives
  'MH', // the Marshall Islands
  'NL', // the Netherlands
  'PH', // the Philippines
  'SB', // the Solomon Islands
  'TC', // the Turks and Caicos Islands
  'AE', // the United Arab Emirates
  'GB', // the United Kingdom
  'US', // the United States
  'VI', // the US Virgin Islands
];

export const addDefiniteArticleToCountryName = (
  countryName: string,
  countryCode: string,
): string => {
  if (countriesWithDefiniteArticle.includes(countryCode)) {
    return `the ${countryName}`;
  }
  return countryName;
};
